import { Box, Divider, Grid, Typography } from "@mui/material";
import { useState } from "react";
import { addContainerShipping } from "../../http/api/ContainerAPI";
import StyledModal from "../../components/drawers/StyledModal";
import ContainerForm from "./ContainerForm";
import HistoryContainerItem from "./HistoryContainerItem";

const Storing = (props) => {
  const { open, setOpen, buyers } = props;
  const [containers, setContainers] = useState([]);
  async function submitContainer(container) {
    const body = { ...container, quantity: -container.quantity };
    const transactionId = await addContainerShipping(body);
    setContainers([{ ...container, transactionId }, ...containers]);
  }

  return (
    <StyledModal open={open} setOpen={setOpen}>
      <Box display="flex" sx={{ padding: 1, width: 1700 }}>
        <Grid container display="flex" flexDirection="row">
          <Grid item display="flex" flexDirection="column" xs={3.5}>
            <ContainerForm
              submitContainer={submitContainer}
              closeModal={() => setOpen(false)}
              buyers={buyers}
            />
          </Grid>

          <Divider orientation="vertical" sx={{ p: 1 }} />
          {/* History */}

          <Grid
            item
            display="flex"
            flexDirection="column"
            xs={8.3}
            sx={{ px: 1 }}
          >
            <Typography variant="h6" textAlign="left" mb={3}>
              履歴
            </Typography>
            {/* {containers.map((item) => (
            ))} */}

            <HistoryContainerItem containers={containers} />
          </Grid>
        </Grid>
      </Box>
    </StyledModal>
  );
};
export default Storing;
